import React from 'react';
import BackRow from 'components/BackRow/BackRow';
import Card from 'components/Card/Card';
import { EditText } from 'components/EditText/EditText';
import { post, dodelete, put, upload } from 'lib/comms';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import SwitchBar from 'components/SwitchBar/SwitchBar';
import EditBrowse from 'components/EditBrowse/EditBrowse';
import './PromoBanner.css';

import * as S from './PromoBanner.styled';

import 'react-quill/dist/quill.snow.css';

export default class PromoBannerItem extends React.Component {
    constructor(props) {
        super(props);

        this.fileInputRef = React.createRef();
        const isNew = props.promoBannerItem && props.promoBannerItem.id === 'new';

        const banner = isNew
            ? {
                  id: 'new',
                  active: 1,
                  promotionName: '',
                  files: [
                      {
                          url: '',
                          file: '',
                      },
                  ],
              }
            : props.promoBannerItem;

        this.state = {
            ...banner,
            isNew,
            isEditing: isNew,
        };
    }

    // refresh the item
    reload = async () => {};

    componentDidMount = () => this.reload();

    // on toggle edit/save
    toggleEditingStatus = () => {
        const { isEditing } = this.state;
        this.setState({ isEditing: !isEditing });
    };

    onChangeFileUrl = (index, url) => {
        if (url.length > 254) return;
        let files = [...this.state.files];
        files[index] = {
            ...files[index],
            url: url,
        };

        this.setState({
            files: files,
        });
    };

    onChangePromotionName = (title) => {
        if (title.length > 254) return;
        this.setState({
            name: title,
        });
    };

    onFileChange = (file, index) => {
        let files = [...this.state.files];

        files[index] = {
            ...files[index],
            file: file,
            original_name: file.name,
        };

        this.setState({
            files: files,
        });
    };

    onClickAddFiles = () => {
        let files = [
            ...this.state.files,
            {
                url: '',
                file: '',
            },
        ];
        if (files.length > 5) {
            this.setState({
                showMessage: {
                    message: 'You can add maximum of 5 files',
                    title: 'Message',
                },
            });
            return;
        }

        this.setState({
            files: files,
        });
    };

    removeFile = (index) => {
        const files = [...this.state.files];
        files.splice(index, 1);

        this.setState({
            files: files,
        });
    };

    // upload files item to backend before update/create of  banner item
    uploadFiles = async () => {
        const { files } = this.state;
        let fileIds = [];
        const fileCount = files.length;
        for (let index = 0; index < fileCount; index++) {
            const fileItem = files[index];
            if (!fileItem.id) {
                const fileResp = await upload(
                    `cms/upload_file/${fileItem.title}/promo_banner`,
                    'file',
                    fileItem.file,
                    true,
                );
                if (fileResp && fileResp['file_id']) {
                    fileIds.push({
                        fileId: fileResp['file_id'],
                        fileURL: fileItem.url,
                    });
                }
            } else {
                fileIds.push({
                    fileId: fileItem.id,
                    fileURL: fileItem.url,
                });
            }
        }
        return fileIds;
    };

    // on toggle edit/save
    toggleEditingStatus = () => {
        const { isEditing } = this.state;
        if (isEditing) {
            this.saveBanner();
        } else {
            this.setState({ isEditing: !isEditing });
        }
    };

    saveBanner = async () => {
        let bannerId = this.state.id;
        let resp = null;
        let { isEditing, files, active, name } = this.state;

        if (isEditing) {
            if (!name) {
                return this.setState({
                    showMessage: { message: 'Please include a valid title', title: 'Save Promotion Banner' },
                });
            }

            if (!files.length) {
                return this.setState({
                    showMessage: { message: 'Please add a valid banner', title: 'Save Promotion Banner' },
                });
            }

            for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
                const file = files[fileIndex];

                if (!file.url || !file.original_name) {
                    return this.setState({
                        showMessage: { message: 'Please include a valid file', title: 'Save promotion Banner' },
                    });
                }
            }
        }

        const bannerItem = {
            name: name,
            active: active,
        };

        const fileIds = await this.uploadFiles();

        bannerItem['fileIds'] = fileIds;

        if (this.state.isNew) {
            resp = await post('cms/promo_banner', bannerItem, true);
        } else {
            resp = await put(`cms/promo_banner/${this.state.id}`, bannerItem, true);
        }

        if (resp && resp.success) {
            this.setState(
                {
                    isNew: false,
                    isEditing: false,
                    id: resp.item ? resp.item.id : bannerId,
                },
                this.reload,
            );
        } else {
            this.setState({
                showMessage: { message: 'Could not create banner.', title: 'Save error' },
            });
        }
    };

    doDelete = async () => {
        const resp = await dodelete(`cms/promo_banner/${this.state.id}`, {}, true);
        if (resp && resp.success) {
            this.props.onBack();
        } else if (resp.message) {
            setTimeout(
                () =>
                    this.setState({
                        showMessage: {
                            message: resp.message,
                            title: 'Delete Banner',
                        },
                    }),
                500,
            );
        }
    };

    render() {
        let { isEditing, files, name, active } = this.state;

        return (
            <div className="maincontainer">
                <BackRow
                    onBack={this.props.onBack}
                    buttonTitle={this.state.isNew ? null : 'DELETE ITEM'}
                    onDelete={() => this.setState({ showDeleteDialog: true })}
                    accept="image/jpg, image/png"
                />

                <Card title="Promotional Banner" editing={isEditing} onToggle={this.toggleEditingStatus}>
                    <S.VerticalSpacer size={35} />

                    <SwitchBar
                        className="mb-4"
                        editing={isEditing ? '1' : undefined}
                        options={['Active', 'Archived']}
                        values={[1, 0]}
                        value={active}
                        onChange={(value) => this.setState({ active: value })}
                    />

                    <EditText
                        outerClassName="mt-3 mb-3 w-50"
                        label="Banner Name"
                        editing={isEditing}
                        onChange={(name) => this.onChangePromotionName(name)}
                        value={name}
                    />
                    {files.map((file, index) => (
                        <S.FileContainer>
                            <EditText
                                outerClassName="mt-3 mb-3 w-50"
                                label="Promotion URL"
                                editing={isEditing && !file.original_name}
                                onChange={(url) => this.onChangeFileUrl(index, url)}
                                value={file.url}
                            />
                            <S.HorizontalSpacer size={20} />
                            <EditBrowse
                                editing={isEditing && !file.original_name}
                                onFileChange={(slctdFile) => this.onFileChange(slctdFile, index)}
                                fileName={file['original_name']}
                                acceptFileTypes={'image/gif, image/jpeg, image/png'}
                            />
                            <S.HorizontalSpacer size={20} />
                            <button
                                className="btn btn-remove"
                                onClick={() => this.removeFile(index)}
                                disabled={!isEditing}
                                isEditing={isEditing && !file.original_name}
                            >
                                Remove
                            </button>
                        </S.FileContainer>
                    ))}

                    <S.BottomFileContainer>
                        <button
                            className="btn btn-primary knowledgebase-btn"
                            disabled={!isEditing}
                            onClick={this.onClickAddFiles}
                        >
                            ADD FILES
                        </button>
                    </S.BottomFileContainer>
                    {this.state.showMessage ? (
                        <MessageDialog
                            message={this.state.showMessage.message}
                            title={this.state.showMessage.title}
                            onClose={() => this.setState({ showMessage: null })}
                        />
                    ) : null}
                    {this.state.showDeleteDialog ? (
                        <DeleteDialog
                            item="Banner"
                            onSuccess={this.doDelete}
                            onClose={() => this.setState({ showDeleteDialog: false })}
                        />
                    ) : null}
                </Card>
            </div>
        );
    }
}

const localStyle = {
    subtitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#000',
    },
    typeTitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#000',
        marginLeft: 8,
    },
    TypeSubtitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#505A62',
        textAlign: 'left',
        marginLeft: 8,
        marginTop: 3,
    },
};
